// extracted by mini-css-extract-plugin
export default {"resultContainer":"ResultTable_resultContainer__GkdyW","rowSurvey":"ResultTable_rowSurvey__necN8","surveyName":"ResultTable_surveyName__n2jNZ","answer":"ResultTable_answer__lK8d4"};